module.exports = __webpack_public_path__ + "img/error.4bc43c6c.png";